export default __webpack_public_path__ + "static/media/Yes.b54a51c4.svg";